import { Component, Injector, OnInit } from '@angular/core';
import { BaseComponent } from 'src/app/shared/baseComponent';

@Component({
  selector: 'app-userlist',
  templateUrl: './userlist.component.html',
  styleUrls: ['./userlist.component.css']
})
export class UserlistComponent extends BaseComponent implements OnInit {
  users: any = [];
  organizations: any = []
  sortDirName = true
  sortDirUName = true
  sortDirOrg = false

  constructor(injector: Injector) { super(injector) }

  async ngOnInit() {
    this.loader.show();
    this.organizations = await this.db.get("organization","getorganizations");
    this.users = await this.db.get("Authenticate","getallusers");
    this.users = this.sort(this.users,"userName")

    this.loader.hide();
  }
  edituser(user: any){
    this.router.navigate(['useredit'],{ queryParams: { id: user.id } })
  }
  add(){
    this.router.navigate(['useredit'],{ queryParams: { id: "0" } })
  }
  sortCol(sCol: string){
    if (sCol == "firstName") this.sortDirName = this.sortUpDown(this.users, "firstName", this.sortDirName) 
    if (sCol == "userName") this.sortDirUName = this.sortUpDown(this.users, "userName", this.sortDirUName) 
    if (sCol == "organization") this.sortDirOrg = this.sortUpDown(this.users, "organizationId", this.sortDirOrg) 
  }
}
